module.exports = __webpack_public_path__ + "static/pen-bbde6ce958e04f6041016823b297579b.jpg";